<div oui-dialog-title>
  {{ dialogTitle }}
  <oui-button type="icon" oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>

<oui-stepper
  oui-dialog-stepper
  [steps]="steps"
  [displayNumbers]="true"
  direction="horizontal"
  class="padding-lateral-24"
  (currentStepChange)="onStepChange($event)"
  (stepStateChange)="onStepStateChange($event)"
#stepper></oui-stepper>

<oui-dialog-content class="color-on-surface-emphasis">
  @if (this.stepper?.currentStep?.title == DOCUMENT_STEP_TITLE) {
    <div class="flex-vertical">
      <div class="padding-bottom-8">Sélectionnez les documents à envoyer au partenaire</div>
      <div class="flex-horizontal align-self-center">
        @if (!files?.length) {
          <oui-loading size="small"></oui-loading>
        }
      </div>
      <div class="flex-horizontal gap-16 body-2">
        @if (files && files.length > 0) {
          <div class="padding-16 flex-horizontal gap-8">
            <oui-checkbox
              (checkedChange)="toggleAllRows()"
              [checked]="selection.length > 0 && isAllSelected()"
              [indeterminate]="selection.length > 0 && !isAllSelected()">
            </oui-checkbox>
            {{ selection.length }}
            @if (selection.length > 1) {
              <span>documents sélectionnés</span>
            }
            @if (selection.length < 2) {
              <span>document sélectionné</span>
            }
          </div>
        }
      </div>
      <div class="flex-vertical rounded with-border">
        @for (file of files; track file; let eltIndex = $index) {
          <div
            class="flex-horizontal height-56"
            [ngClass]="eltIndex > 0 ? 'with-border-top' : ''">
            <div class="align-self-center padding-lateral-16 padding-vertical-4 flex-1 flex-horizontal gap-16">
              <oui-checkbox
                [checked]="selection.includes(file.identifier)"
              (checkedChange)="toggleFileSelection(file.identifier)"></oui-checkbox>
              {{ file.denomination }}
            </div>
            <div class="align-self-center padding-lateral-16 padding-vertical-4 flex-1 flex-horizontal gap-16">
              {{ file.filename }}
            </div>
            <div class="align-self-center padding-lateral-16 padding-vertical-4 flex-horizontal gap-16">
              {{ file.sizeInMB }} Mo
            </div>
          </div>
        }
      </div>
    </div>
  }
  @if (this.stepper?.currentStep?.title == MAIL_STEP_TITLE) {
    <div class="flex-vertical flex-start gap-24">
      <oui-textfield type="email" label="De" [control]="mailFromControl" class="width-100pc"> </oui-textfield>
      <oui-textfield type="email" label="A" [control]="mailToControl" class="width-100pc"> </oui-textfield>
      <oui-textfield type="email" label="Cc" [control]="mailCcControl" class="width-100pc"> </oui-textfield>
      <oui-textfield type="text" label="Objet" [control]="mailObjectControl" class="width-100pc"> </oui-textfield>
      <oui-textarea label="Message" [control]="mailContentControl" class="width-100pc"> </oui-textarea>
    </div>
  }
</oui-dialog-content>
<oui-dialog-actions>
  @if (this.stepper?.currentStep?.title == DOCUMENT_STEP_TITLE) {
    <oui-button type="text" (click)="onCancel()"> Annuler </oui-button>
    <oui-button
      type="contained"
      (click)="onNextStepClick()"
      [disabled]="selection.length == 0"
      iconSuffix="arrow_forward">
      Etape suivante
    </oui-button>
  }

  @if (this.stepper?.currentStep?.title == MAIL_STEP_TITLE) {
    <oui-button
      type="text"
      iconPrefix="arrow_back"
      color="primary"
      (click)="onPreviousStepClick()"
      [disabled]="isSending">
      Etape précédente
    </oui-button>
    <div class="flex-1"></div>
    <oui-button class="align-self-center" type="text" (click)="onCancel()" [disabled]="isSending"> Annuler </oui-button>
    @if (!isSending) {
      <oui-button
        class="align-self-center"
        type="contained"
        (click)="onSendEmailClick()"
        [disabled]="!mailToControl.valid || !mailContentControl.valid || !mailObjectControl.valid || isSending">
        Envoyer l'e-mail
      </oui-button>
    } @else {
      <div class="flex-horizontal align-self-center">
        <oui-loading size="small"></oui-loading>
      </div>
    }
  }
</oui-dialog-actions>
